import { useCallback } from 'react';
import {
	type UpdateQueryParamAction,
	useViewPreference,
	HIDE_SOFTWARE_RELEASE_PREFERENCE,
} from '@atlassian/jira-business-preferences';

export const useHideSoftwareRelease = () => {
	const [hideSoftwareRelease, persistSoftwareRelease] = useViewPreference(
		HIDE_SOFTWARE_RELEASE_PREFERENCE,
	);

	const setSoftwareRelease = useCallback(
		(hide: boolean, action: UpdateQueryParamAction = 'push') =>
			persistSoftwareRelease(hide ? 'true' : undefined, action),
		[persistSoftwareRelease],
	);

	return [hideSoftwareRelease === 'true', setSoftwareRelease] as const;
};
